import type { Dispatch, ThunkAction } from '@avalara/types/actions';
import type { State } from '@avalara/types/reducer-states';
import { setConnector } from '../actions';

export const selectConnector =
  (connectorId: string): ThunkAction =>
  async (dispatch: Dispatch, getState: () => State): Promise<void> => {
    const {
      data: {
        connectors: { data },
      },
    } = getState();
    const connector = data.find((c) => c.id === connectorId);
    if (connector) dispatch(setConnector(connector));
  };
